import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useForm, FormProvider } from 'react-hook-form';
import UserForm from '#component/user/form';
import { updateBreadcrumb } from '#action/breadcrumb';
import { addUser } from '#action/user/settings';
import { reduxFormResolver } from '#helper/rhf-resolver';
import validate from '#component/user/form/validate';
import { setDocumentTitle } from '#helper';

const AddUserForm = props => {
  const { history, account, initialValues, addUser: dispatchAddUser, dispatch } = props;

  const methods = useForm({
    resolver: reduxFormResolver(validate),
    defaultValues: initialValues
  });

  const { handleSubmit, reset } = methods;

  useEffect(() => {
    setDocumentTitle('Add user');
    dispatch(
      updateBreadcrumb([
        { label: 'Users', path: '/user' },
        { label: 'Add user' }
      ])
    );
  }, [dispatch]);

  const handleFormSubmit = async values => {
    const QUALITY_MANAGER_TYPE = 1;
    const {
      firstName,
      lastName,
      phoneNumber,
      email,
      userType,
      projectId,
      emailMsg = 0,
      siteMsg = 0,
      notificationMsg = 0,
      measurementSystem,
      defaultPage
    } = values;

    const type = parseInt(userType, 10);

    const userData = {
      firstName: firstName?.trim(),
      lastName: lastName?.trim(),
      phoneNumber,
      email,
      userType: type,
      projectId,
      emailMsg: Number(emailMsg),
      siteMsg: Number(siteMsg),
      notificationMsg: Number(notificationMsg),
      measurementSystem,
      defaultPage
    };

    if (userType === `${QUALITY_MANAGER_TYPE}`) {
      userData.allowManageAlertAcceptance = QUALITY_MANAGER_TYPE;
      userData.userType = account.userType;
    }

    try {
      await dispatchAddUser(
        userData,
        () => {
          history.push('/user');
          reset();
        }
      );
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(handleFormSubmit)} autoComplete="off" style={{ width: '100%' }}>
        <UserForm
          title="Add new user"
          {...props}
          isSubmitting={methods.formState.isSubmitting}
          isDirty={methods.formState.isDirty}
          editable={true}
        />
      </form>
    </FormProvider>
  );
};

function mapStateToProps(state) {
  const { account, account: defaultProject } = state;

  return {
    initialValues: {
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
      userType: '10',
      measurementSystem: 'metric',
      defaultPage: '/device',
      emailMsg: false,
      siteMsg: false,
      notificationMsg: false
    },
    account,
    projects: [defaultProject]
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addUser(data, callback) {
      return dispatch(addUser(data, callback));
    },
    dispatch
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddUserForm);
